const childrenLoaded = require('@alexspirgel/children-loaded');

class TextBlock extends HTMLElement {
    constructor() {
        super();
    }

    async connectedCallback() {
        await childrenLoaded(this);
        const links = this.querySelectorAll('a[target="_blank"]');
        if (!links.length) {
            return;
        }

        links.forEach((link) => {
            if (link.querySelector('img')) {
                link.classList.add('has-image')
            }
        });
    }
}

customElements.define('block-text', TextBlock, {extends: 'section'});